import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerSummaryStatsModel
} from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerSummaryStatsModel";

export class ProSkillManagerAssessmentSummaryModel extends Model {
  constructor(
    public total: number = 0,
    public upcoming: number = 0,
    public ended: number = 0,
    public live: number = 0,
    public stats: ProSkillManagerSummaryStatsModel = new ProSkillManagerSummaryStatsModel()
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerAssessmentSummaryModel>): ProSkillManagerAssessmentSummaryModel {
    return createModel<ProSkillManagerAssessmentSummaryModel>(ProSkillManagerAssessmentSummaryModel, {
      ...model
    });
  }
}
